import Swal from "sweetalert2";
import { call, put, takeLeading } from "redux-saga/effects";
import { Color } from "../../assets/colors";
import * as actionTypes from '../actionTypes';
import { deleteAPI, getAPI, postAPI, putAPI } from "../../utils/api-function";
import { all_consultant_requests, create_daily_darshan, delete_daily_darshan, get_daily_darshan, update_daily_darshan } from "../../utils/api-routes";

function* getDailyDarshan() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_daily_darshan);
        console.log("Get Daily Darshan Saga Response ::: ", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_DAILY_DARSHAN, payload: data?.data?.reverse() });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Daily Darshan Saga Error ::: ", error);
    }
};


function* createDailyDarshan(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield postAPI(create_daily_darshan, payload?.data);
        console.log("Create Daily Darshan Saga Response ::: ", data);

        if (data?.success) {
            Swal.fire({ icon: "success", title: 'Success', text: "Daily Darshan Created Successfully", showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message || 'Failed', showConfirmButton: false, timer: 2000 });
        console.log("Create Daily Darshan Saga Error ::: ", error);
    }
};

function* updateDailyDarshan(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield postAPI(update_daily_darshan, payload?.data);
        console.log("Update Daily Darshan Saga Response ::: ", data);

        if (data?.success) {
            Swal.fire({ icon: "success", title: 'Success', text: "Daily Darshan Updated Successfully", showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message || 'Failed', showConfirmButton: false, timer: 2000 });
        console.log("Update Daily Darshan Saga Error ::: ", error);
    }
};

function* deleteDailyDarshan(action) {
    try {
        const { payload } = action;
        console.log("Delete Daily Darshan Saga payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete!!!", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: 'grey', confirmButtonText: "Yes", cancelButtonText: "No" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(delete_daily_darshan, payload);
            console.log("Delete Daily Darshan Saga Response ::: ", data);

            if (data?.success) {
                Swal.fire({ icon: "success", title: 'Success', text: "Daily Darshan Deleted Successfully", showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes?.GET_DAILY_DARSHAN, payload: null });
            }
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: "Failed To Delete", showConfirmButton: false, timer: 2000 });
        console.log("Delete Daily Darshan Saga Error ::: ", error);
    }
};

function* consultantData() {
   try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(all_consultant_requests);
        console.log("Get Daily Darshan Saga Response ::: ", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_CONSULTANT_DATA, payload: data?.results?.reverse() });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Daily Darshan Saga Error ::: ", error);
    }
}

export default function* religiousSaga() {
    yield takeLeading(actionTypes?.GET_DAILY_DARSHAN, getDailyDarshan);
    yield takeLeading(actionTypes?.CREATE_DAILY_DARSHAN, createDailyDarshan);
    yield takeLeading(actionTypes?.UPDATE_DAILY_DARSHAN, updateDailyDarshan);
    yield takeLeading(actionTypes?.DELETE_DAILY_DARSHAN, deleteDailyDarshan);
    yield takeLeading(actionTypes?.GET_CONSULTANT_DATA, consultantData);
};